import Vue from 'vue';

import apiFactory from '@/api/default';
const API = apiFactory('charts');

const state = {
  chartSearchResults: [],
  currentChart: {},
};

const getters = {
  chartSearchResults: (state) => state.chartSearchResults,
  currentChart: (state) => state.currentChart,
};

const mutations = {
  setChartSearchResults: (state, chartSearchResults) => {
    state.chartSearchResults = chartSearchResults;
  },
  updateChartSearchResults: (state, task) => {
    const index = state.chartSearchResults.findIndex((el)=>el._id === task._id);
    if (index >= 0) Vue.set(state.chartSearchResults, index, task);
  },
  removeFromChartSearchResults: (state, id)=>{
    state.chartSearchResults.data = state.chartSearchResults.filter((obj)=>{
      return obj._id !== id;
    });
    state.chartSearchResults.total--;
  },
  setCurrentChart: (state, currentChart) => {
    state.currentChart = currentChart;
  },
};

const actions = {
  async searchCharts({commit}, payload) {
    const response = await API.search(payload.query, payload.headers);
    commit('setChartSearchResults', response.data);
    return response.data;
  },
  async loadChart({commit}, payload) {
    const response = await API.load(payload.id, payload.query, payload.headers);
    commit('setCurrentChart', response.data);
    return response.data;
  },
  async createChart({commit}, payload) {
    const response = await API.create(payload.data, payload.headers);
    return response.data;
  },
  async updateChart({commit}, payload) {
    const response = await API.update(payload.id, payload.data, payload.headers);
    commit('updateChartSearchResults', response.data);
    return response.data;
  },
  async deleteChart({commit}, payload) {
    const response = await API.remove(payload.id, payload.headers);
    commit('removeFromChartSearchResults', payload.id);
    return response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
